export default {
  log(item) {
    console.log(item)
  },
  declOfNum(number, titles) {
    let cases = [2, 0, 1, 1, 1, 2];
    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
  },
  closestByClass(node, className) {
    while (node) {
      if (node.classList.contains(className)) {
        return node;
      } else {
        node = node.parentElement;
      }
    }
    return null;
  },
  inputSize (num) {
    switch (num) {
      case 3:
        return 'col-lg-4 col-xl-3';
        break;
      case 4:
        return 'col-lg-6 col-xl-4';
        break;
      case 6:
        return 'col-lg-6 col-xl-6';
        break;
      case 12:
        return 'col-lg-12 col-xl-12';
        break;
      default:
        return 'col-lg-6 col-xl-4';
    }
  },
}



// WEBPACK FOOTER //
// ./src/helpers.js